import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export const Footer = () => (
  <footer className="relative border-t border-[#27272A] bg-ink-900 overflow-hidden" data-testid="footer">
    <div
      className="absolute inset-0 opacity-[0.12] bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1524562865630-b991c6c2f261?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/85 to-ink-900/60" />

    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-5">
            <span className="h-3 w-3 bg-accent block" />
            <span className="font-display font-extrabold tracking-tight text-2xl">RECOVERY SUPPS</span>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Australia's premier source for clinical-grade research peptides. Lab tested for purity,
            cold-packed and dispatched express, Australia-wide.
          </p>
          <a href="mailto:recoverysuppsaus@gmail.com" className="inline-block mt-4 font-mono-tech text-sm text-zinc-300 hover:text-accent transition-colors" data-testid="footer-email">
            recoverysuppsaus@gmail.com
          </a>
          <div className="flex gap-6 mt-8">
            {["Purity > 99%", "Lab Tested", "AU Owned"].map((t) => (
              <span key={t} className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-zinc-500">
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-500 mb-5">Shop</h4>
          <ul className="space-y-3">
            {[
              { to: "/shop?goal=recovery", label: "Recover & Heal" },
              { to: "/shop?goal=lean", label: "Lean & Summer-Ready" },
              { to: "/shop?goal=performance", label: "Performance & Growth" },
              { to: "/shop?goal=essentials", label: "Lab Essentials" },
              { to: "/shop", label: "All Products" },
            ].map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-zinc-300 hover:text-accent transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-500 mb-5">
            Compliance
          </h4>
          <ul className="space-y-3 mb-5">
            {[
              { to: "/policies#research", label: "Research Use Policy" },
              { to: "/policies#shipping", label: "Shipping & Returns" },
              { to: "/policies#terms", label: "Terms & Conditions" },
              { to: "/policies#privacy", label: "Privacy" },
            ].map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-zinc-300 hover:text-accent transition-colors text-sm">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="border border-accent/40 bg-accent/5 p-4 clip-corner">
            <div className="flex gap-2 text-accent mb-2">
              <AlertTriangle size={16} />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest">
                Research use only
              </span>
            </div>
            <p className="text-xs text-zinc-400 leading-relaxed">
              All products are research chemicals supplied for laboratory research use only. Not for
              human consumption. Not a therapeutic good, food or supplement. Not intended to diagnose,
              treat, cure or prevent any disease.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#27272A] flex flex-col md:flex-row justify-between gap-4">
        <span className="font-mono-tech text-[11px] tracking-wider text-zinc-600">
          © {new Date().getFullYear()} RECOVERY SUPPS AUSTRALIA — MELBOURNE · SYDNEY · PERTH
        </span>
        <span className="font-mono-tech text-[11px] tracking-wider text-zinc-600">
          You must be 18+ to purchase.
        </span>
      </div>
    </div>
  </footer>
);
